<template>
    <div class="paginator">
        <div>
            <button
                class="prev"
                @click="getPage(currentPage - 1)"
                :disabled="currentPage == 1"
            >
                <span class="sr-only">{{ $t("labels.previous_page") }}</span>
            </button>
            <button
                v-for="(num, i) in totalPages"
                :key="i"
                @click="getPage(i + 1)"
                class="num"
                :class="{
                    current: currentPage == i + 1,
                    display: inPageRange(i + 1),
                }"
            >
                {{ i + 1 }}
            </button>
            <button
                class="next"
                @click="getPage(currentPage + 1)"
                :disabled="currentPage == totalPages.length"
            >
                <span class="sr-only">{{ $t("labels.next_page") }}</span>
            </button>
        </div>
        <div>
            <label for="page">{{ $t("labels.go_to_page") }}</label>
            <input
                name="page"
                id="page"
                type="number"
                :value="currentPage"
                @change="getPageDelayed"
                :max="totalPages.length"
            />
        </div>
    </div>
</template>

<script>

export default {
	name: "Pagination",
    props: {
        currentPage: Number,
        totalPages: Array,
    },
    methods: {
        inPageRange(page) {
			let alwaysShow = [1, 2];
			alwaysShow.push(this.totalPages.length - 1, this.totalPages.length);

			if (page > this.currentPage * 1 - 3 && page < this.currentPage * 1 + 3) {
				return true;
			} else if (alwaysShow.includes(page)) {
				return true;
			} else {
				return false;
			}
		},
        getPage(page) {
            this.$emit('turn', page)
        },
        getPageDelayed(e) {
            setTimeout(() => {
                this.getPage(e.target.value)
            }, 2000);
        },
    }
};
</script>

<style scoped lang="scss">
.paginator {
	display: flex;
	align-items: center;
	justify-content: center;

	div {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	button {
		background: none;
		border: none;
		text-decoration: none;
		padding: 0;
		text-transform: capitalize;
		margin: 0 0.5rem;

		&.current {
			text-decoration: underline;
			color: $cmh-red;
			text-underline-offset: 3px;
		}

		&.num {
			display: none;
			&.display {
				display: inline-block;
			}
		}

		&.num:not(.display) + .num.display {
			margin-left: 20px;
			position: relative;

			&:before {
				position: absolute;
				top: 0;
				left: -22px;
				content: "…";
				display: block;
			}
		}

		&.next {
			margin-left: $s2;
			&:after {
				content: url("../assets/images/icon-arrow-go.svg");
				transform: scale(0.5);
				display: block;
			}
		}
		&.prev {
			margin-right: $s2;
			&:after {
				content: url("../assets/images/icon-arrow-back.svg");
				transform: scale(0.5);
				display: block;
			}
		}

		&[disabled] {
			&:after {
				opacity: 0.5;
			}
		}
	}

	label {
		// text-transform: capitalize;
		margin-left: $s4;
	}

	input {
		max-width: 50px;
		padding: 5px;
		margin: 0 0.5rem;
	}
}
@media (max-width: $mq-max-width-desktop-sml) {
    .paginator {
		flex-direction: column;

		div {
			margin-bottom: $s1;
		}
		label {
			margin-left: 0;
		}
	}
}
@media print {
	.paginator {
		display: none;
		background: $white;
	}
}
</style>
